import styled from 'styled-components';

import { NorlysColor } from '~src/branding';

export const UnderlineNorlys = styled.div({
  width: '100px',
  margin: '8px 32px',
  borderBottom: `2px solid ${NorlysColor.primary.acid}`,
});
